import { EMessageStatus } from '@/store/messageStore';
import { FC } from 'react';
import { SpinComp, FailComp, ReadTickComp } from '@/Icons';
import { callFromExternal } from '@/utils';
import { getValue } from '@/externalConfig/conf'
interface IBubbleStatus {
  status: EMessageStatus;
  className?: string;
  onClick?: (status: EMessageStatus) => void;
}
const external = callFromExternal()
const BubbleStatus: FC<IBubbleStatus> = ({ status, className, onClick }) => {
  if (status === EMessageStatus.fail) {
    return (
      external ? <img src={getValue('sendFailed')} className="external-msg-status flex-48 md:flex-16" onClick={() => onClick?.(EMessageStatus.fail)} /> : 
      <FailComp
        className={`w-48 md:w-24 ${className}`}
        onClick={() => onClick?.(EMessageStatus.fail)}
      />
    );
  }

  if (status === EMessageStatus.pending) {
    return (
      <SpinComp
        onClick={() => onClick?.(EMessageStatus.pending)}
        className={`w-48 md:w-24 ${className}`}
      />
    );
  }
  if (status === EMessageStatus.success) {
    return <></>;
  }
};
export default BubbleStatus;

/**
 * handle message had read
 */
export const BubbleReadStatus: FC<{ isRead: boolean; className?: string }> = ({
  isRead,
  className,
}) => {
  if (isRead) {
    return (external ? <img src={getValue('read')} className="external-msg-status flex-48 md:flex-16" /> : <ReadTickComp className={`flex-48 md:flex-16 ${className}`} />);
  }

  return <></>;
};
